import { Row, Col, Badge, Spinner } from "react-bootstrap";
import Logo from "../icons/Logo";
import { Link, route } from "preact-router";
import { clearPreferences } from "../../lib/preferences";
import IsicomStatus from "../isicom-status";
import config from "../../lib/config";
import { NotificationContext } from "../notification-provider";
import { useContext, useState } from "preact/hooks";
import { render } from "preact";
import { clearCache } from "../../api/cache";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator, faFileContract, faUser } from "@fortawesome/free-solid-svg-icons";
import { AlgoliaAutocomplete } from "../algolia-autocomplete";
import { getAlgoliaResults } from "@algolia/autocomplete-js";
import algoliasearch from "algoliasearch/lite";
import { capitalizeFirstLetter } from "../../lib/utils";
import TicketSaveModal from "../ticket-save-modal";
import useUserStore from "../../store/userStore";
import { ROLES } from "../../lib/security/roles";


const searchClient = process.env.ALGOLIA_APP_ID && process.env.ALGOLIA_SECRET
    ? algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SECRET)
    : null;

export default function Navbar(props) {

    const { logoutUser } = useUserStore();
    const { addNotification } = useContext(NotificationContext);
    const [isClearingCache, setIsClearingCache] = useState(false);
    const [ticketModalOpen, setTicketModalOpen] = useState(false);

    const currentRoute = window.location.pathname;
    const isLoginPage = currentRoute.includes("login");
    const user = useUserStore.getState().user;
    const user_quick_search = user.metadata?.quick_search ?? false;

    // Périmètre de recherche du commercial : ses partners + sa liste de produits autorisés.
    // Les admins (super-admin) ne sont pas filtrés.
    const isAdmin = (user.roles ?? []).includes(ROLES.SUPER_ADMIN);
    const partnerIds = (user.partners ?? []).map((p) => p.id);
    const productCodes = user.metadata?.product_filter ?? [];

    const partnerFilter = partnerIds.map((id) => `partner_id:${id}`).join(" OR ");
    const productFilter = productCodes.map((code) => `product_code:"${code}"`).join(" OR ");

    // Filtre Algolia par catégorie. Pour un non-admin sans partner, on bloque tout (sécurité).
    const customerFilters = isAdmin ? undefined : (partnerFilter || "partner_id:-1");
    const policyQuoteFilters = isAdmin
        ? undefined
        : [partnerFilter || "partner_id:-1", productFilter]
            .filter(Boolean)
            .map((f) => `(${f})`)
            .join(" AND ");

    // N'ajoute `filters` aux params que s'il a une valeur : passer `filters: undefined`
    // est sérialisé en "filters=undefined" par Algolia et casse la recherche (0 résultat).
    const buildParams = (filters) => (filters ? { filters } : undefined);

    if (!user) {
        return route('/login')
    }

    function clearPrefs() {
        let ok = confirm("Voulez-vous vraiment supprimer les préférences ?");
        if (ok) {
            clearPreferences();
            addNotification("Vos préférences ont été effacé !", "success");
        }
    }
    async function doClearCache() {
        let ok = confirm("Voulez-vous vraiment vider le cache ?");

        if (ok) {
            try {
                setIsClearingCache(true);

                const response = await clearCache();

                if (response.data.success === true) {
                    // get all keys that start with cache_

                    let keys = Object.keys(localStorage).filter((key) => {
                        return key.startsWith("cache_");
                    });

                    // remove all keys

                    keys.forEach((key) => {

                        // except the darkMode key
                        if (key === "darkMode") {
                            return;
                        }

                        localStorage.removeItem(key);
                    });

                    addNotification("Le cache a été vidé !", "success");

                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error(response.data.message);
                }
            } catch (ex) {
                console.error(ex);
                addNotification(ex.message, "danger");
            } finally {
                setIsClearingCache(false);
            }
        }
    }

    function toggleDarkMode() {
        let ok = confirm("Voulez-vous vraiment changer le mode sombre ?");

        if (ok) {
            let darkMode = !props.darkMode;
            localStorage.setItem("darkMode", darkMode);
            window.location.reload();
        }
    }


    if (isClearingCache) {
        return <div className="bg-dark text-white h-100 d-flex flex-column p-2">
            <div className="d-flex justify-content-center align-items-center flex-grow-1">
                <Spinner animation="border" />
            </div>
        </div>;
    }


    const SEARCH_COLUMN_HEADERS = {
        policies: { label: "Contrats", badgeClass: "bg-primary" },
        quotes: { label: "Devis", badgeClass: "bg-success" },
        customers: { label: "Clients", badgeClass: "bg-danger" },
    };

    return (
        <>
            {ticketModalOpen ? (<>
                <TicketSaveModal
                    show={ticketModalOpen}
                    handleClose={() => setTicketModalOpen(false)}
                />
            </>) : null}

            <div id="topbar" class="navbar fixed-top bg-white ">
                <div class="container-fluid justify-content-start align-items-center">
                    <div class="navbar-brand">
                        <Link href="/" className="text-decoration-none">
                            <div className="d-flex align-items-center justify-content-center text-dark gap-2 w-fit">
                                <Logo
                                    kColor="white"
                                    textColor="black"
                                    onClick={() => (window.location = "/")}
                                />
                                <div className="extra-bold fs-2">360</div>
                            </div>
                        </Link>

                    </div>
                    <div class="px-4 flex-grow-1 justify-content-center align-items-center">
                        {!isLoginPage && !!user_quick_search ? <AlgoliaAutocomplete
                            openOnFocus={true}
                            render={({ sections }, root) => {
                                // On affiche TOUJOURS les 3 colonnes (contrats, devis, clients) à
                                // largeur fixe, même si une catégorie n'a aucun résultat, pour que
                                // la disposition ne bouge pas pendant la frappe.
                                // Algolia n'émet une section que si elle a des résultats ; on la
                                // retrouve via son data-autocomplete-source-id.
                                const sectionBySource = {};
                                sections.forEach((section) => {
                                    const sourceId = section?.props?.["data-autocomplete-source-id"];
                                    if (sourceId) sectionBySource[sourceId] = section;
                                });
                                render(
                                    <div className="aa-PanelLayout aa-Panel--scrollable">
                                        <div className="d-flex align-items-start gap-3 k360-search-columns">
                                            {Object.keys(SEARCH_COLUMN_HEADERS).map((sourceId) => {
                                                const header = SEARCH_COLUMN_HEADERS[sourceId];
                                                return (
                                                    <div className="k360-search-column" key={sourceId}>
                                                        <div className={`badge ${header.badgeClass} text-white mb-2 k360-search-column-title`}>
                                                            {header.label}
                                                        </div>
                                                        {sectionBySource[sourceId] ?? null}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>,
                                    root
                                );
                            }}
                            getSources={({ query }) => [
                                {
                                    sourceId: 'policies',
                                    getItems() {
                                        return getAlgoliaResults({
                                            searchClient,
                                            queries: [
                                                {
                                                    indexName: 'policies',
                                                    query,
                                                    params: buildParams(policyQuoteFilters),
                                                },
                                            ],
                                        });
                                    },
                                    onSelect: ({ item }) => {
                                        route(`/save-policy/${item.id}`);
                                    },
                                    templates: {
                                        item({ item }) {
                                            return (
                                                <div className={`d-flex align-items-center px-2 rounded`} style={{
                                                    backgroundColor: 'rgba(0,0,128,0.05)',
                                                    fontSize: '0.8rem'
                                                }}>

                                                    <div
                                                        style={{ width: '40px', height: '40px' }}
                                                        className={`me-2 rounded-circle  bg-primary text-white p-2 d-flex align-items-center justify-content-center`}>
                                                        <FontAwesomeIcon icon={faFileContract} className={``}
                                                            size={'2x'} />
                                                    </div>

                                                    <div className={`p-2 d-flex align-items-start flex-column gap-1`}>

                                                        <strong>
                                                            Contrat n°{item.id} {
                                                                item.status === 'active' ?
                                                                    <span className="badge bg-success ms-2">Actif</span> :
                                                                    item.status === 'pending' ?
                                                                        <span className="badge bg-warning text-dark ms-2">En attente</span> :
                                                                        item.status === 'expired' ?
                                                                            <span className="badge bg-danger ms-2">Expiré</span> :
                                                                            <span className="badge bg-dark text-white ms-2">Non défini</span>
                                                            }
                                                        </strong>

                                                        <span>
                                                            {item.customer}
                                                        </span>

                                                        <span>
                                                            {capitalizeFirstLetter(item.product_type)}
                                                        </span>

                                                    </div>

                                                </div>
                                            );
                                        },
                                    },
                                },
                                {
                                    sourceId: 'quotes',
                                    getItems() {
                                        return getAlgoliaResults({
                                            searchClient,
                                            queries: [
                                                {
                                                    indexName: 'quotes',
                                                    query,
                                                    params: buildParams(policyQuoteFilters),
                                                },
                                            ],
                                        });
                                    },
                                    onSelect: ({ item }) => {
                                        route(`/save-quote/${item.id}`);
                                    },
                                    templates: {
                                        item({ item }) {

                                            return (
                                                <div className={`d-flex align-items-center px-2 rounded`}
                                                    style={{
                                                        backgroundColor: 'rgba(0,128,0,0.05)',
                                                        fontSize: '0.8rem'
                                                    }}>

                                                    <div
                                                        style={{ width: '40px', height: '40px' }}
                                                        className={`me-2 rounded-circle  bg-success text-white p-2 d-flex align-items-center justify-content-center`}>
                                                        <FontAwesomeIcon icon={faCalculator}
                                                            size={'2x'} />
                                                    </div>

                                                    <div className={`p-2 d-flex align-items-start flex-column gap-1`}>
                                                        <strong>
                                                            Devis n°{item.id} {
                                                                item.status === 'validated' || item.status === 'active' ?
                                                                    <span className="badge bg-success ms-2">Validé</span> :
                                                                    item.status === 'pending' ?
                                                                        <span className="badge bg-warning text-dark ms-2">En attente</span> :
                                                                        item.status === 'expired' ?
                                                                            <span className="badge bg-danger ms-2">Expiré</span> :
                                                                            <span className="badge bg-secondary ms-2">{item.status}</span>
                                                            }
                                                        </strong>
                                                        <span>
                                                            {item.customer}
                                                        </span>
                                                        <span>
                                                            {capitalizeFirstLetter(item.product_type)}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        },
                                    },
                                },
                                {
                                    sourceId: 'customers',
                                    getItems() {
                                        return getAlgoliaResults({
                                            searchClient,
                                            queries: [
                                                {
                                                    indexName: 'customers',
                                                    query,
                                                    params: buildParams(customerFilters),
                                                },
                                            ],
                                        });
                                    },
                                    onSelect: ({ item }) => {
                                        route(`/save-customer/${item.id}`);
                                    },
                                    templates: {
                                        item({ item }) {
                                            return (
                                                <div className={`d-flex align-items-center px-2 rounded`} style={{
                                                    backgroundColor: 'rgba(128,0,0,0.05)',
                                                    fontSize: '0.8rem'
                                                }}>

                                                    <div
                                                        style={{ width: '40px', height: '40px' }}
                                                        className={`me-2 rounded-circle  bg-danger text-white p-2 d-flex align-items-center justify-content-center`}>
                                                        <FontAwesomeIcon icon={faUser}
                                                            size={'2x'} />
                                                    </div>

                                                    <div className={`p-2 d-flex align-items-start flex-column gap-1`}>


                                                        <strong>
                                                            Client n°{item.id} {
                                                                item.is_active || item.status === 'active' ?
                                                                    <span className="badge bg-success ms-2">Actif</span> :
                                                                    item.status === 'inactive' || !item.is_active ?
                                                                        <span className="badge bg-secondary ms-2">Inactif</span> :
                                                                        <span className="badge bg-secondary ms-2">{item.status}</span>
                                                            }
                                                        </strong>

                                                        <div className={`d-flex align-items-center gap-2`}>


                                                            <span>
                                                                {item.fullname}
                                                            </span>

                                                            <span>
                                                                - {item.postal_code} {item.city}
                                                            </span>

                                                        </div>

                                                        <div className={`d-flex align-items-center gap-2`}>

                                                            <span>
                                                                {item.mobile_phone}
                                                            </span>

                                                            <em>
                                                                {item.primary_email}

                                                            </em>

                                                        </div>
                                                    </div>

                                                </div>
                                            );
                                        },
                                    },
                                },
                            ]}
                        /> : null}

                    </div>
                    {user ? (
                        <Row className={`align-items-center`}>
                            {config.isicom.enable ? (
                                <Col className={`d-flex justify-content-end`}>
                                    <IsicomStatus isicom={props.isicom} />
                                </Col>
                            ) : null}
                            <Col className={`d-flex justify-content-end`}>
                                <div class="btn-group  dropstart" role="group">
                                    <button type="button" class="btn btn-white dropdown-toggle"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        {user.email ?? "..."}
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <a class="dropdown-item" href="#" onClick={clearPrefs}>
                                                Effacer les préférences
                                            </a>

                                            <a class="dropdown-item" onClick={toggleDarkMode}>
                                                Mode sombre

                                                <Badge
                                                    pill
                                                    bg={props.darkMode ? "success" : "danger"}
                                                    className={`ms-2`}
                                                >
                                                    {props.darkMode ? "Activé" : "Désactivé"}
                                                </Badge>
                                            </a>

                                            <a class="dropdown-item" href="/profile">
                                                Mon compte
                                            </a>

                                            <a class="dropdown-item" href="#" onClick={logoutUser}>
                                                Déconnexion
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    ) : null}
                </div>
            </div>
        </>);

}
